export default "__VITE_ASSET__aMoRXEBE__"